import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
// import { NotificationsService } from 'angular2-notifications';
import { BaseDataService, BaseUpdateComponent, NotificationService } from 'yt-ng-framework';
import { RadnoMestoPoslovi } from './radno-mesto-poslovi';
// import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'yt-radno-mesto-poslovi-stavka-update',
  templateUrl: './radno-mesto-poslovi-stavka-update.component.html'
})
export class RadnoMestoPosloviStavkaUpdateComponent 
  extends BaseUpdateComponent<RadnoMestoPoslovi>
  implements OnInit {

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected baseDataService: BaseDataService,
    // protected notificationService: NotificationsService,
    protected toastrService: NotificationService,
    protected translateService: TranslateService
  ) { 
    super(activatedRoute, baseDataService, toastrService, translateService)
  }

  ngOnInit() {
    super.ngOnInit();
    // this.addValidatorToFc('PosloviID', Validators.required, 'required', 'RADNOMESTOPOSLOVI.POSLOVI.VALIDATION.REQUIRED');
  }

  editMode:boolean=false;
  SaveMaster(qq){}
  Cancel(){}
}
